module.exports = __webpack_public_path__ + "static/media/withdraeScreen.36220a7e.png";